<script>
export default {
  name: 'AlignedWrapper',

  functional: true,

  props: {
    gray: {
      type: Boolean,
      required: false,
    },

    expanded: {
      type: Boolean,
      required: false,
    },

    tag: {
      type: String,
      required: false,
      default: 'div',
    },
  },

  render(h, { props, data, children, listeners }) {
    children = children.filter(c => c.tag);
    if (children.length === 0) return;
    return h(props.tag, { data, on: listeners, staticClass: 'row aligned', class: { gray: props.gray, expanded: props.expanded } }, children);
  },
};
</script>

<style scoped lang="scss">
@import '~@scss';

.aligned ::v-deep {
  display: flex;
  flex-flow: row wrap;
  height: 100%;
  padding: 12px;
  margin-top: 12px;
  margin-right: 0;
  margin-left: 0;
  list-style-type: none;

  .form-fieldset {
    padding: 0;
  }

  .form-fieldset:last-of-type {
    padding-bottom: 6px;
  }

  .dl {
    padding: 6px 0 0 0;
    margin: 0;
  }

  .box {
    min-height: 90px;
    padding-top: 12px;
    padding-bottom: 12px;

    .db-hl {
      padding: 0 0 6px;
      margin: 0;
    }

    &:focus {
      outline: 0;
    }
  }

  .notification-heading {
    padding-bottom: 3px;
    font-size: 15px;
    color: $font-color-light;
  }

  .inner-aligned {
    display: table;
    width: 100%;
    height: 100%;
    table-layout: fixed;

    .notification {
      height: 100%;
      padding: 0;
      margin: 0;
      overflow: hidden;

      .heading-spacing {
        display: table;

        .notification-content {
          display: table-cell;
          vertical-align: middle;
        }
      }

      .notification-inner {
        padding: 16px 24px;
        margin-bottom: 6px;
      }
      .notification-inner.table {
        padding: 0;
        margin-top: -3px;
        margin-bottom: -1px;
      }

      .grayed {
        height: 105%;
        padding: 12px 24px 16px;
        margin-top: -6px;
        margin-bottom: 6px;
      }
    }
    .notification.subtract-db-hl {
      height: calc(100% - 31px);
    }
  }
}

.aligned.gray {
  padding: 12px;
  margin-top: -6px;
  background-color: #ececec;
  border-top: 6px solid white;
}

.aligned.expanded {
  padding: 0;
  margin-right: -12px;
  margin-left: -12px;
}

.gray:last-child {
  padding-bottom: 24px;
  margin-bottom: -12px;
}
</style>
